import elUpload from "./el-upload"
import elCheckGroup from "./el-checkbox-group"
export default {
    'el-upload': elUpload,
    'el-checkbox-group': elCheckGroup
}